// removed by extract-text-webpack-plugin
module.exports = {"block":"_35r0Hiw5mAG4HyDr32epW8","text":"_3AbLitX-6qi05ul10we8DD","heading":"_14WUzMddIG6UMpN6Kmd7Zj","intro":"_2WslV20ulCmvojKMp_qEaq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DoYouHaveQuestionsBlock/DoYouHaveQuestionsBlock.module.scss
// module id = 749
// module chunks = 0